// Constants TypeScript files should be AUTO-GENERATED by the Typewriter Visual Studio plugin. Do not modify this file.
enum CompressorOffReason {
    UserRequested = 'UserRequested',
    OverrideRequested = 'OverrideRequested',
    AmbientTemperature = 'AmbientTemperature',
    RestBetweenCycles = 'RestBetweenCycles',
}
export default CompressorOffReason;
